<template>
  <div class="panels">
    <div v-if="show && authenticatedUser !== null" class="panel-status">
      <div class="item-title d-flex align-items-center">
        <img src="/images/error-codes/400-bad-request.svg" alt="Error" v-if="serverResponseCode === 400" />
        <img src="/images/error-codes/401-unauthorized.svg" alt="Error" v-if="serverResponseCode === 401" />
        <img src="/images/error-codes/403-forbidden.svg" alt="Error" v-if="serverResponseCode === 403" />
        <img src="/images/flag.svg" alt="Error" v-if="serverResponseCode === 404" />
        <img src="/images/flag.svg" alt="Error" v-if="serverResponseCode === 405" />
        <img src="/images/flag.svg" alt="Error" v-if="serverResponseCode === 406" />
        <img src="/images/flag.svg" alt="Error" v-if="serverResponseCode === 415" />
        <img src="/images/error-codes/500-internal-server-error.svg" alt="Error" v-if="serverResponseCode === 500" />
        <img src="/images/error-codes/500-internal-server-error.svg" alt="Error" v-if="serverResponseCode === 501" />
        <img src="/images/error-codes/502-bad-gateway.svg" alt="Error" v-if="serverResponseCode === 502" />
        <img src="/images/error-codes/503-service-unavailable.svg" alt="Error" v-if="serverResponseCode === 503" />
        <img src="/images/error-codes/504-gateway-timeout.svg" alt="Error" v-if="serverResponseCode === 504" />
        &nbsp;
        <b-badge class="ml-2" variant="danger">{{ code }}</b-badge>
        &nbsp;&nbsp;
        <p>  
          {{ message }}
        </p>
      </div>
      <div v-if="show" class="options mr-2">
        <b-btn
          variant="outline-secondary"
          class="ml-2"
          @click="close"
        >
          Ok
        </b-btn>
        <b-btn
          v-if="code === 401"
          variant="primary"
          class="ml-2"
          @click="logout"
        >
          Quit &amp; Login
        </b-btn>
      </div>
    </div>
    <!--<div v-if="passStatus === 'no'" class="panel-status">
      <div class="item-title">
        <p>
          <img src="/images/flag.svg" alt="Error" />
          &nbsp;
          <b-badge class="ml-2" variant="danger">MND111X</b-badge>
          &nbsp;&nbsp;
          Password expired, please update to continue using Mynd
        </p>
      </div>
      <div class="options mr-2">
        <b-btn
          variant="outline-secondary"
          class="ml-2"
          @click="updatePass"
        >
          Update Password
        </b-btn>
      </div>
    </div>-->
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";

export default {
  name: "App",
  data() {
    return {
      show: false,
      code: null,
      message: null,
    };
  },
  computed: {
    ...mapState({
      serverResponse: (state) => state.admin.serverResponse,
      serverResponseCode: (state) => state.admin.serverResponseCode,
      authenticatedUser: (state) => state.auth.authenticatedUser
      //passStatus: (state) => state.auth.passStatus
    }),
  },
  watch: {
    serverResponse() {
      this.updateStatusBar();
    },
    serverResponseCode() {
      this.updateStatusBar();
    },
  },
  mounted() {
    this.updateStatusBar();
  },
  methods: {
    updateStatusBar() {
      if (this.serverResponseCode && this.serverResponseCode !== "null") {
        this.code = "MYND22" + this.serverResponseCode + "BE";
        this.message = this.serverResponse;
        this.show = true;
      }
      if (this.serverResponseCode) {
      //if (this.serverResponse && this.serverResponse !== "null") {  
        /*
        if (this.serverResponseCode === 400) {
          this.message =
            "Mynd cannot recognize this request. Contact Mynd admin for proper guidance";
        } else if (this.serverResponseCode === 401) {
          this.message =
            "Your session timed out OR you have been logged out of Mynd. Login again to continue";
        } else if (this.serverResponseCode === 403) {
          this.message = 
            "Forbidden! You have consumed your allocated quota for this";
        } else if (this.serverResponseCode === 404) {
          this.message =
            "Mynd cannot recognize the request. Contact Mynd admin for proper guidance";
        } else if (this.serverResponseCode === 405) {
          this.message =
            "Not Allowed at this time. Login again to continue";
        } else if (this.serverResponseCode === 406) {
          this.message =
            "Mynd cannot recognize the request. Contact Mynd admin for proper guidance";
        } else if (this.serverResponseCode === 500) {
          this.message =
            "Mynd has encountered some problem. Please login again to continue working";
        } else if (this.serverResponseCode === 501) {
          this.message =
            "Mynd cannot recognize the request. Contact Mynd admin for proper guidance";
        } else if (this.serverResponseCode === 502) {
          this.message = 
            "Mynd is too busy! Please retry in few seconds.";
        } else if (this.serverResponseCode === 503) {
          this.message =
            "Mynd facing issues to process your requests. Please refresh OR start as fresh";
        } else if (this.serverResponseCode === 504) {
          this.message =
            "Mynd failed to complete your request this time. Plrease try again";
        } else {
          this.message =
            "Oops! Mynd failed to complete your request. Machines do that sometimes! We are working hard to prevent that in future";
        }
        this.show = true;
        */
      }
    },
    updatePass() {
      this.$router.push({'name': 'UpdatePassword'});
    },
    close() {
      this.code = null;
      this.message = null;
      this.show = false;
    },
    logout() {
      Vue.prototype.$authService.logout();
    },
  },
};
</script>
